<template>
	<div>
		<a-layout>
			<a-layout-sider style="background: #FFFFFF;overflow: hidden; height: 100vh;" width="200px">
				<div style="padding: 30px 20px;">
					<div v-for="(item,index) in menus" :key="index" @click="goToUrl(index)" class="second-menu-item "
						:class="{on:getSelectKey.indexOf(item.key) > -1}">
						<i class="iconfont ft14" :class="item.icon"></i>
						<span class="ft14 ml10">{{item.name}}</span>
					</div>
				</div>
			</a-layout-sider>
			<a-layout-content style="padding: 30px 20px;height: 100vh; background: #F7F8FA;">
				<div>
					<router-view></router-view>
				</div>
			</a-layout-content>
		</a-layout>

	</div>
</template>

<script>
	export default {

		data() {
			return {
				showForm: false,

				menus: [
					// {
					// 	name: '项目管理',
					// 	icon: 'iconproject',
					// 	key: 'project_index',
					// 	link: '/project'
					// },
					// {
					// 	name: '抢购管理',
					// 	icon: 'iconqianggou',
					// 	key: 'project_snapup',
					// 	link: '/project/snapup'
					// },
					// {
					// 	name: '抢购订单',
					// 	icon: 'iconmall_order',
					// 	key: 'project_orderSnapup',
					// 	link: '/project/orderSnapup'
					// },
					{
						name: '卡片管理',
						icon: 'iconcountingcard',
						key: 'project_oncecard',
						link: '/project/oncecard'
					},
					{
						name: '充值卡订单',
						icon: 'iconmall_order',
						key: 'card_order_rechargecard',
						link: '/card/orderRechargecard'
					},
					{
						name: '项目卡订单',
						icon: 'iconmall_order',
						key: 'project_order_oncecard',
						link: '/project/orderOncecard'
					},
					{
						name: '活动卡订单',
						icon: 'iconmall_order',
						key: 'card_order_activity',
						link: '/card/orderActivitycard'
					},
				],
			}
		},
		created() {
			this.filterMenusByPermission();
		},
		methods: {
			filterMenusByPermission() {
				// 获取权限字符串
				const caidanStr = localStorage.getItem('beautiful-caidan');
				if(caidanStr == 'all'){
					return;
				}
				const allowedKeys = caidanStr.split(',');
				
				// 过滤菜单
				this.menus = this.menus.filter(menu => 
					allowedKeys.includes(menu.key)
				);
        	},
			goToUrl(index) {
				this.refreshPage(this.menus[index].link);
			},
		}
	}
</script>

<style>

</style>
